import { Guid, ModifiedResponse } from '@fitscovery/common/types';
import { PaymentMethodStatus } from '../enums';

export interface PartnerPaymentsStateModel {
  paymentMethods: PaymentMethod[] | null;
  partnerPaymentMethods: PaymentMethod[] | null;
  partnerPayments: PartnerPayments | null;
  loaded: boolean;
};

// **********************************
// Payment method response interfaces
// **********************************

interface PaymentMethodsResponse {
  paymentMethods: PaymentMethod[];
}

export interface PartnerPaymentsResponse extends PaymentMethodsResponse {
  paymentsPartner: PartnerPayments;
}

export interface GetPaymentMethodsResponse {
	data: PaymentMethodsResponse
}

export interface PartnerPaymentMethodsResponse {
	data: PartnerPaymentsResponse;
}

// ******************************
// Payment method core interfaces
// ******************************

export interface PaymentMethod {
	id: string;
  name: string;
  description: string;
	status: PaymentMethodStatus;
  parentPaymentMethodId: Guid;
  childPaymentMethods: PaymentMethod[];
  createdAt: string;
  updatedAt: string;
}

export interface PartnerPayments extends ModifiedResponse {
  id: string
  name: string
  subdomain: string
  partnerPaymentMethods: PaymentMethod[]
  accountName: string;
  accountNumber: string;
  bankName: string;
  currency: string; // get type
  countryCode: string;
  enablePayout: boolean;
  bankDetailsUpdatedAt: any; // get enum
  payoutMethod: PayoutMethod;
  payoutEmail: string;
  payoutRate: number;
  payoutRateUpdatedAt: any; // get type
}

export interface PayoutMethod extends ModifiedResponse {
  channelCode: boolean,
  channelType: string; // get enum
  description: string;
  id: string;
  maximumPerTransaction: any; // get type
  name: string;
  status: string; // get enum
}
